module.exports = __webpack_public_path__ + "static/media/truckWContainer.6b43e1d2.svg";